<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Documento de respaldo MTO-FDOC-05 - {{ code }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div>
  <div class="form-group m-4">
    <div *ngIf="file">
      <div class="d-flex justify-content-center" style="max-height: 60px; border: 1px solid rgb(199, 199, 199); border-radius: 5px; padding: 5px; margin-bottom: 5px; overflow: hidden; text-overflow: ellipsis;">
        <p style="text-overflow: ellipsis; width: 90%; height: auto;">{{file.name}}</p>
        <button class="btn" (click)="removeUploadingFile(fileInput)"><i class="fas fa-times"></i></button>
      </div>
    </div>

    <div class="custom-file">
        <label 
          class="custom-file-label" 
          style="color: #787878;" 
          for="fileAttachment"
          [ngClass]="{
            'is-invalid': (submitted && file === null) || fileSizeError,
            'is-valid': file !== null && !fileSizeError
          }"
        >
          Seleccione el documento a cargar
        </label>

        <input 
          #fileInput
          id="fileAttachment"
          class="form-control custom-file-input"
          style="cursor: pointer;"
          type="file"
          accept="application/pdf"
          max="1"
          (change)="onFileSelected($event)"
        >
    </div>

    <div *ngIf="submitted && file === null" class="invalid-feedback">
      <div *ngIf="file === null">Documento requerido</div>
    </div>

    <div *ngIf="fileSizeError" class="invalid-feedback d-block">
      El archivo excede el tamaño máximo permitido (15 MB)
    </div>
  </div>
  
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="loading"
      (click)="modal.dismiss('cancel click')"
    >
      Cancelar
    </button>
    <button
      ngbAutofocus
      type="button"
      class="btn btn-primary"
      [disabled]="loading"
      (click)="onSubmit()"
    >
      <span
        *ngIf="loading"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      Aceptar
    </button>
  </div>
</div>
